module.exports = __webpack_public_path__ + "static/media/storyImage.e8e23dba.png";